<template>
  <SAIPageWrapper>
    <CarSearchTabs />
    <div class="column q-gutter-y-lg">
      <div>
        <SAITitle text-align="left">
          Get a quote for the car you want
        </SAITitle>
        <p class="q-pt-sm">
          To obtain a quote for you, our team will need to know the exact car
          you want.
        </p>
      </div>
      <div>
        <SAIFormLabel>Car Condition</SAIFormLabel>
        <NewUsedList
          :disable="disable"
          :value="findCar.newUsed"
          @input="$emit('update:newUsed', $event)"
        />
      </div>

      <div>
        <SAIFormLabel>Make</SAIFormLabel>
        <CarSearchSelect
          :disable="loadingMakes || disable"
          :loading="loadingMakes"
          @input="$emit('update:make', $event)"
          class="col-12"
          :options="makes"
          :value="findCar.makeId"
        />
      </div>

      <div class="text-justify-center" v-if="bodyTypes.length">
        <SAIFormLabel>Body Type</SAIFormLabel>
        <div class="row q-gutter-sm scroll">
          <div v-for="option in bodyTypes" :key="option.id">
            <SAICardToggle
              :disable="disable"
              :active="option.id === findCar.bodyType"
              @click="$emit('update:bodyType', option.id)"
            >
              <p class="text-weight-medium q-py-md q-px-lg text-capitalize">
                {{ option.name.toLowerCase() }}
              </p>
            </SAICardToggle>
          </div>
        </div>
      </div>

      <div>
        <SAIFormLabel>Model</SAIFormLabel>
        <CarSearchSelect
          :disable="loadingModels || disable"
          :loading="loadingModels"
          class="col-12"
          @input="$emit('update:model', $event)"
          :options="models"
          :value="findCar.modelId"
        />
      </div>

      <div v-if="transmissions.length > 0">
        <SAIFormLabel>Transmission</SAIFormLabel>
        <div class="row q-gutter-sm scroll">
          <div v-for="option in transmissions" :key="option.id">
            <SAICardToggle
              :disable="disable"
              :active="option.id === findCar.transmission"
              @click="$emit('update:transmission', option.id)"
            >
              <p class="text-weight-medium q-py-md q-px-lg">
                {{ option.name }}
              </p>
            </SAICardToggle>
          </div>
        </div>
      </div>

      <div class="full-width" v-if="findCar.transmission && years.length">
        <SAIFormLabel>Year</SAIFormLabel>
        <div class="row q-gutter-sm no-wrap scroll">
          <div v-for="option in years" :key="option">
            <SAICardToggle
              :disable="disable"
              :active="option === findCar.year"
              @click="$emit('update:year', option)"
            >
              <p class="text-weight-medium q-py-md q-px-lg">
                {{ option }}
              </p>
            </SAICardToggle>
          </div>
        </div>
      </div>
      <SAIMessage
        v-else-if="findCar.transmission"
        class="full-width"
        variant="info"
      >
        We have not found a match
      </SAIMessage>

      <div class="row q-mt-lg justify-center">
        <SAIBtn
          label="Find my car"
          no-caps
          padding="12px xl"
          :disable="disable || searchDisable"
          :loading="saving"
          @click="$emit('next:searchDetail')"
        />
      </div>
    </div>
  </SAIPageWrapper>
</template>
<script>
import {
  SAIBtn,
  SAIPageWrapper,
  SAITitle,
  SAIFormLabel,
  SAICardToggle,
  SAIMessage
} from 'ecx.saigon.ui.common';

export default {
  name: 'CarSearch',
  props: {
    disable: Boolean,
    findCar: {
      type: Object,
      default: () => ({})
    },
    makes: {
      type: Array,
      default: () => []
    },
    bodyTypes: {
      type: Array,
      default: () => []
    },
    models: {
      type: Array,
      default: () => []
    },
    transmissions: {
      type: Array,
      default: () => []
    },
    years: {
      type: Array,
      default: () => []
    },
    searchDisable: Boolean,
    loadingMakes: Boolean,
    loadingModels: Boolean,
    saving: Boolean
  },
  components: {
    SAIPageWrapper,
    SAIBtn,
    SAITitle,
    SAIFormLabel,
    SAICardToggle,
    SAIMessage,
    CarSearchSelect: () => import('../../atom/car-search-select'),
    CarSearchTabs: () => import('../../../widgets/car-search-tabs'),
    NewUsedList: () => import('../../atom/new-used-list')
  }
};
</script>
